import { render, staticRenderFns } from "./OrderRelationOrders.vue?vue&type=template&id=1ad29fca&"
import script from "./OrderRelationOrders.vue?vue&type=script&lang=js&"
export * from "./OrderRelationOrders.vue?vue&type=script&lang=js&"
import style0 from "./OrderRelationOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports